import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'header-dr',
  templateUrl: './header-dr.component.html',
  styleUrls: ['./header-dr.component.scss']
})
export class HeaderDr implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
